var map = {
	"./PaellaCorePlugins.js": 3537,
	"./es.upv.paella.canvasButtonPluginTest.js": 3244,
	"./es.upv.paella.collisionTestShortucts.js": 1268,
	"./es.upv.paella.defaultShortcuts.js": 4807,
	"./es.upv.paella.dfxpManifestCaptionsPlugin.js": 2740,
	"./es.upv.paella.dynamicWidthButton.js": 9680,
	"./es.upv.paella.nonInteractiveButtonTest.js": 3242,
	"./es.upv.paella.playPauseButton.js": 5943,
	"./es.upv.paella.testButtonGroupPlugin.js": 9063,
	"./es.upv.paella.testCaptionsPlugin.js": 635,
	"./es.upv.paella.testEventLogPlugin.js": 2522,
	"./es.upv.paella.testFoldableButton.js": 8588,
	"./es.upv.paella.testMenuTitleElement.js": 3774,
	"./es.upv.paella.testPopUp2Button.js": 1343,
	"./es.upv.paella.testPopUpButton.js": 4689,
	"./es.upv.paella.testProgressIndicatorPlugin.js": 1732,
	"./es.upv.paella.testVideoContainerButton.js": 6413,
	"./es.upv.paella.vttManifestCaptionsPlugin.js": 6664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3099;